// ** Utils
import {
    canViewMenuGroup,
    canViewMenuItem,
    resolveVerticalNavMenuItemComponent as resolveNavItemComponent
} from "@layouts/utils";

import { AbilityContext } from "@context/can";
import VerticalNavMenuGroup from "./menu-group";
// ** Vertical Menu Components
import VerticalNavMenuLink from "./nav-menu-links";
import { useContext } from "react";
import { useTranslation } from "react-i18next";

const MenuNavItems = (props) => {
    
    const { t } = useTranslation();
    const ability = useContext(AbilityContext);
    // ** Components Object
    const Components = {
        VerticalNavMenuLink,
        VerticalNavMenuGroup
    };
    // ** Render Nav Menu Items
    const RenderNavItems = props.items.map((item = {}, index) => {
        const TagName = Components[resolveNavItemComponent(item)];
        if (item.show && item.header && item.show) {
            return (
                <li className="navigation-header" key={index}
                    data-cy={`nav-${item.header}`}>
                    <span>{t(item.header)}</span>
                </li>
            );
        }
        if (item.children && item.show && item.show) {
            return (
                canViewMenuGroup(item, ability) && (
                    <TagName
                        data-cy={`nav-${item.id}`}
                        item={item}
                        index={index}
                        key={item.id}
                        {...props}/>
                )
            );
        }

        return (
            canViewMenuItem(item) && item.show && item.resource && (
                <TagName
                    data-cy={`nav-${item.id}`}
                    key={item.id}
                    item={item}
                    {...props}/>
            )
        );
    });

    return RenderNavItems;
};

export default MenuNavItems;